import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';
import { getDualApiChatbot } from '../../services/chatbots/dualApiMergeChatbotService';

const resource = `${MERCATELY_API}/chatbots`;

const model = abstractModel(resource);

model.findById = async (webId) => {
  return getDualApiChatbot(webId);
};

export default model;
